import { actionTextColor } from "../utils/themeContrast";
import { readableText, lightTint } from "../utils/themeContrast";
import React, { useState } from "react";
import { ThemeContext, ActionContext, LanguageContext, UserContext } from "../contexts/Context";
import styled from "@emotion/styled";
import { navigate } from "@reach/router"
import ReviewOrderModal from './ReviewOrderModal';
import { IoReaderOutline, IoReceiptOutline, IoArrowBack, IoPersonOutline, IoSearchOutline, IoCloseCircle, IoCartOutline } from "react-icons/io5";
import AdvocadoLogin from "./advocadoComponents/AdvocadoLogin";
import AdvocadoPage from "./advocadoComponents/AdvocadoPage";
import moment from "moment";

import CustomerLogin from "./customerComponents/CustomerLogin";
import CustomerDetail from "./customerComponents/CustomerDetail";
import TakeAwayModal from "./optioncomponents/TakeAwayModal";

const Header = ({ hasBack, wide = false, maxWidth, showMobileCart = false, cartQuantity = 0, cartAmount = null, currencySymbol = "", onCartClick, mobileCollapsed = false, mobileMenuHeader = false, mobileSearchInHeader = false, categorySearch = false }) => {
    const languageContext = React.useContext(LanguageContext);
    const themeContext = React.useContext(ThemeContext);
    const { lanIndex, isTakeAway, isMenuView, isInRoom, tableLabel, company, tkType, supportMultiLan, hasCategoryScreen, hasAdvocado, adCustomer, isSearching: contextSearching, hasMember, customer, showLogo, showCompanyName, takeAwayInfo, deliveryCalMethod } = React.useContext(UserContext);
    const isSearching = !categorySearch && contextSearching;
    const { setLanIndex, setIsSearch, setSearchTxt, setSearching, addTakeAwayInfo, setTkType } = React.useContext(ActionContext);
    const [showOrder, setShowOrder] = useState(false);
    const [showAdvocadoLogin, setShowAdvocadoLogin] = useState(false);
    const [showAdCustomer, setShowAdCustomer] = useState(false);
    const [showCustomerLogin, setShowCustomerLogin] = useState(false);
    const [showCustomer, setShowCustomer] = useState(false);
    const [showTakeawayEditor, setShowTakeawayEditor] = useState(false);
    const [editorDeliveryPrice, setEditorDeliveryPrice] = useState(0);
    const [editorBaseDeliveryPrice, setEditorBaseDeliveryPrice] = useState(0);

    const handleLanIndex = (lanIndex) => (e) => {
        setLanIndex(lanIndex);
    }

    if (typeof lanIndex === 'undefined') {
        return <></>
    }
    const hasTakeawayDetails = isTakeAway && takeAwayInfo && Object.keys(takeAwayInfo).length > 0 && !isSearching;
    const orderType = takeAwayInfo && Number(takeAwayInfo.deliveryType) === 2
        ? languageContext[lanIndex].delivery
        : takeAwayInfo && Number(takeAwayInfo.deliveryType) === 1
            ? "Dine In"
            : languageContext[lanIndex].takeAway;
    const scheduledTime = takeAwayInfo && takeAwayInfo.scheduleTime && moment(takeAwayInfo.scheduleTime).isValid()
        ? moment(takeAwayInfo.scheduleTime).format("DD MMM, h:mm A")
        : "";
    const mobileDeliveryType = hasTakeawayDetails ? Number(takeAwayInfo.deliveryType) : Number(tkType);
    const mobileOrderTypeLabels = languageContext[lanIndex].mobileOrderType;
    const mobileOrderType = isMenuView ? mobileOrderTypeLabels.eMenu : isInRoom ? mobileOrderTypeLabels.inRoomDining : isTakeAway
        ? (mobileDeliveryType === 2 ? mobileOrderTypeLabels.delivery : mobileDeliveryType === 1 ? mobileOrderTypeLabels.dineIn : mobileOrderTypeLabels.pickup) : mobileOrderTypeLabels.dineIn;
    const mobileCustomerName = (hasTakeawayDetails && takeAwayInfo.customerName) || (customer && customer.customerName)
        || (adCustomer && [adCustomer.firstName, adCustomer.lastName].filter(Boolean).join(" ")) || "Guest Customer";
    const mobilePhone = (hasTakeawayDetails && takeAwayInfo.phone) || (customer && customer.phone) || (adCustomer && adCustomer.phoneNumber) || "";
    const pickupMoment = hasTakeawayDetails && takeAwayInfo.scheduleTime ? moment(takeAwayInfo.scheduleTime) : null;
    const pickupMinutes = pickupMoment && pickupMoment.isValid() ? Math.ceil(pickupMoment.diff(moment(), "minutes", true)) : null;
    const mobileSchedule = pickupMoment && pickupMoment.isValid()
        ? (pickupMoment.isSame(moment(), "day")
            ? (pickupMinutes > 0 ? `Today, in ${pickupMinutes} mins` : `Today, ${pickupMoment.format("h:mm A")}`)
            : pickupMoment.format("DD MMM, h:mm A")) : "";
    const customerDetail = takeAwayInfo
        ? [takeAwayInfo.customerName, takeAwayInfo.phone].filter(Boolean).join(" · ")
        : "";
    const locationDetail = takeAwayInfo
        ? (Number(takeAwayInfo.deliveryType) === 2 ? takeAwayInfo.address : takeAwayInfo.roomNo)
        : "";
    const bookingDate = takeAwayInfo && takeAwayInfo.scheduleTime && moment(takeAwayInfo.scheduleTime).isValid()
        ? `${moment(takeAwayInfo.scheduleTime).format("YYYY-MM-DD HH:mm")} - ${moment(takeAwayInfo.scheduleTime).add(15, "minutes").format("HH:mm")}`
        : "";
    const getDeliveryAddressParts = () => {
        const savedAddress = takeAwayInfo && takeAwayInfo.address ? String(takeAwayInfo.address) : "";
        if (!savedAddress) return { address: "", postal: "", unit: "" };
        const postalMatch = savedAddress.match(/(?:Singapore\s*)?(\d{6})\s*$/i);
        const postal = takeAwayInfo.postal || (postalMatch ? postalMatch[1] : "");
        const withoutPostal = postalMatch ? savedAddress.slice(0, postalMatch.index).replace(/,?\s*Singapore\s*$/i, "").replace(/,\s*$/, "") : savedAddress;
        const addressParts = withoutPostal.split(",").map((part) => part.trim()).filter(Boolean);
        if (addressParts.length < 2) return { address: withoutPostal, postal, unit: "" };
        if (Number(deliveryCalMethod) === 0) {
            const unit = takeAwayInfo.unit || addressParts[0];
            const baseParts = takeAwayInfo.unit && addressParts[0] !== takeAwayInfo.unit ? addressParts : addressParts.slice(1);
            return { address: baseParts.join(", "), postal, unit };
        }
        const unit = takeAwayInfo.unit || addressParts[addressParts.length - 1];
        const baseParts = takeAwayInfo.unit && addressParts[addressParts.length - 1] !== takeAwayInfo.unit ? addressParts : addressParts.slice(0, -1);
        return {
            address: baseParts.join(", "),
            postal,
            unit
        };
    };
    const deliveryAddressParts = getDeliveryAddressParts();
    const openTakeawayEditor = () => {
        setEditorDeliveryPrice(Number(takeAwayInfo.deliveryPrice || 0));
        setEditorBaseDeliveryPrice(Number(takeAwayInfo.deliveryBasePrice ?? takeAwayInfo.deliveryPrice) || 0);
        setShowTakeawayEditor(true);
    };
    const updateTakeawayInfo = (customerName, phone, scheduleTime, address, remark, checkbox, deliveryType, roomNo, postal, unit) => {
        const updatedInfo = {
            ...takeAwayInfo,
            customerName,
            phone,
            scheduleTime,
            address,
            remark,
            checkbox,
            deliveryType,
            roomNo,
            postal: postal || "",
            unit: unit || "",
            deliveryPrice: editorDeliveryPrice,
            deliveryBasePrice: editorBaseDeliveryPrice,
            saveTime: new Date().getTime()
        };
        addTakeAwayInfo(updatedInfo);
        setTkType(deliveryType);
        setShowTakeawayEditor(false);
    };
    const renderTakeawaySummary = (desktopOnly = false) => (
        <TakeawaySummary data-mobile-takeaway
            desktopOnly={desktopOnly}
            themeContext={themeContext}
            mobileCollapsed={mobileCollapsed}
            aria-label={`${orderType} order details. Click to edit.`}
            role="button"
            tabIndex={0}
            onClick={openTakeawayEditor}
            onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    openTakeawayEditor();
                }
            }}
        >
            <OrderTypePill themeContext={themeContext}>{orderType}</OrderTypePill>
            {scheduledTime &&
                <TakeawayDetail>
                    <DetailLabel>{Number(takeAwayInfo.deliveryType) === 2 ? languageContext[lanIndex].deliveryTime : languageContext[lanIndex].bookingTime}</DetailLabel>
                    <DetailValue>{scheduledTime}</DetailValue>
                </TakeawayDetail>
            }
            {customerDetail &&
                <TakeawayDetail>
                    <DetailLabel>{languageContext[lanIndex].name}</DetailLabel>
                    <DetailValue>{customerDetail}</DetailValue>
                </TakeawayDetail>
            }
            {locationDetail &&
                <TakeawayDetail location>
                    <DetailLabel>{Number(takeAwayInfo.deliveryType) === 2 ? languageContext[lanIndex].address : languageContext[lanIndex].roomNo}</DetailLabel>
                    <DetailValue title={locationDetail}>{locationDetail}</DetailValue>
                </TakeawayDetail>
            }
        </TakeawaySummary>
    );
    const showAdC = () => {
        setShowAdvocadoLogin(false);
        setShowAdCustomer(true);
    }

    return (
        <React.Fragment>
            <HeaderDisplay maxWidth={maxWidth} mobileMenuHeader={mobileMenuHeader} themeContext={themeContext} wide={wide} isSearching={isSearching} hasTakeawayDetails={hasTakeawayDetails} mobileCollapsed={mobileCollapsed}>
                {mobileMenuHeader && !isSearching &&
                    <MobileIdentity data-mobile-identity themeContext={themeContext} collapsed={mobileCollapsed}>
                        {!mobileCollapsed && company.companyLogo &&
                            <img src={`https://ireachfnb.com${company.companyLogo}`} alt="" />
                        }
                        <div className="identity-text">
                            <strong>{company.shortName || company.companyName}</strong>
                            {!mobileCollapsed && hasTakeawayDetails && mobileSchedule &&
                                <button className="schedule-text" type="button" onClick={openTakeawayEditor}>{mobileOrderType} for {mobileSchedule}</button>
                            }
                            {!isTakeAway && !isMenuView && <span>{languageContext[lanIndex].table} {tableLabel}</span>}
                        </div>
                        <div className="customer-text">
                            {(!mobileCollapsed || isTakeAway || isMenuView) && <span className="order-type">{mobileOrderType}</span>}
                            {!mobileCollapsed && !isMenuView && <>
                                <button type="button" onClick={() => {
                                    if (hasTakeawayDetails) openTakeawayEditor();
                                    else if (hasMember) customer ? setShowCustomer(true) : setShowCustomerLogin(true);
                                    else if (hasAdvocado) adCustomer ? setShowAdCustomer(true) : setShowAdvocadoLogin(true);
                                }}>{mobileCustomerName}</button>
                                {mobilePhone && <span>{mobilePhone}</span>}
                            </>}
                        </div>
                        {!mobileCollapsed && supportMultiLan &&
                            <button className="language-toggle" type="button"
                                onClick={handleLanIndex(lanIndex == 0 ? 1 : 0)}
                                aria-label={lanIndex == 0 ? "Switch to Chinese" : "Switch to English"}
                                title={lanIndex == 0 ? "Switch to Chinese" : "Switch to English"}>
                                {lanIndex == 0 ? "中" : "E"}
                            </button>
                        }
                        {mobileSearchInHeader && <button type="button" aria-label="Search menu" onClick={() => { setIsSearch(true); setSearching(true); }}><IoSearchOutline size={20} /></button>}
                    </MobileIdentity>
                }
                {hasBack && hasCategoryScreen && !isSearching &&
                    <IconButton themeContext={themeContext} onClick={() => {
                        // window.history.back();
                        navigate('/category')
                    }}>
                        <IoArrowBack fontSize={24} />
                    </IconButton>
                }
                {!isSearching && (showLogo || wide) && company.companyLogo &&
                    <HeaderImg
                        desktopOnly={!showLogo}
                        alt={company.shortName || company.companyName || "Company logo"}
                        src={
                            `https://ireachfnb.com${company.companyLogo}`
                            // `https://newdemo.chachingfnb.com${company.companyLogo}`
                        }
                    />
                }

                {hasBack && isSearching &&
                    <SearchTxt
                        autoFocus
                        aria-label="Search menu"
                        themeContext={themeContext}
                        onChange={(e) => { setSearchTxt(e.target.value) }}
                    />
                }

                {hasBack && !categorySearch &&
                    <TableDisplay searchControl isSearching={isSearching} themeContext={themeContext} onClick={() => {
                        if (!isSearching) {
                            setIsSearch(true);
                            setSearching(true);
                            let el = document.getElementById("rightBar");
                            if (el != null) {
                                el.classList.remove("bar-ani");
                            }
                        } else {
                            setIsSearch(false);
                            setSearching(false);
                            setSearchTxt("");
                            let el = document.getElementById("rightBar");
                            if (el != null) {
                                el.classList.add("bar-ani");
                            }
                        }
                    }}>
                        {!isSearching ?
                            <IoSearchOutline fontSize={24} />
                            :
                            <IoCloseCircle fontSize={24} />
                        }
                    </TableDisplay>
                }
                {!isSearching && (showCompanyName || wide) && (company.shortName || company.companyName) &&
                    <HeaderTxt desktopOnly={!showCompanyName} themeContext={themeContext}>{company.shortName || company.companyName}</HeaderTxt>
                }
                {hasTakeawayDetails && renderTakeawaySummary(false)}
                {/* <HeaderLogo image={company.companyLogo} themeContext={themeContext} /> */}
                <RightWrapper id="rightBar" isSearching={isSearching}>
                    {!isSearching &&
                        <>
                            {hasTakeawayDetails && renderTakeawaySummary(true)}
                            {wide && !isMenuView && <ViewBillButton type="button" themeContext={themeContext} onClick={() => setShowOrder(true)}>
                                <IoReceiptOutline size={20} aria-hidden="true" />
                                <span>{lanIndex == 1 ? "\u67e5\u770b\u8d26\u5355" : "View Bill"}</span>
                            </ViewBillButton>}
                            {showMobileCart &&
                                <MobileCartButton
                                    type="button"
                                    themeContext={themeContext}
                                    onClick={onCartClick}
                                    aria-label={`${languageContext[lanIndex].checkout}: ${cartQuantity}`}
                                >
                                    <IoCartOutline aria-hidden="true" size={22} />
                                    <span>{lanIndex == 1 ? `\u672c\u8f6e ${cartQuantity} \u4ef6` : `${cartQuantity} in this round`}</span>
                                    {cartAmount !== null && <span>{currencySymbol}{Number(cartAmount || 0).toFixed(2)}</span>}
                                </MobileCartButton>
                            }
                            {/* {!isTakeAway && !isMenuView &&
                        <TableDisplay themeContext={themeContext}>
                            {languageContext[lanIndex].table}: {tableLabel}
                        </TableDisplay>
                    } */}

                            {!hasTakeawayDetails && isTakeAway && tkType == 0 &&
                                <TableDisplay hideAtDesktop themeContext={themeContext}>
                                    Takeaway
                                </TableDisplay>
                            }
                            {!hasTakeawayDetails && isTakeAway && tkType == 1 &&
                                <TableDisplay hideAtDesktop themeContext={themeContext}>
                                    Dine In
                                </TableDisplay>
                            }
                            {!hasTakeawayDetails && isInRoom &&
                                <TableDisplay hideAtDesktop themeContext={themeContext}>
                                    In Room Dining
                                </TableDisplay>
                            }
                            {isMenuView &&
                                <TableDisplay hideAtDesktop themeContext={themeContext}>
                                    E Menu
                                </TableDisplay>
                            }
                            {supportMultiLan &&
                                <TableLanWrapper themeContext={themeContext}>
                                    <TableLan onClick={handleLanIndex(0)} isSelected={lanIndex === 0} themeContext={themeContext}>En</TableLan>|
                                    <TableLan onClick={handleLanIndex(1)} isSelected={lanIndex === 1} themeContext={themeContext}>中</TableLan>
                                </TableLanWrapper>
                            }

                            <TableDisplay themeContext={themeContext} hideAtDesktop onClick={() => { setShowOrder(true) }}>
                                <IoReaderOutline fontSize={24} />
                                <IconTitle2>{languageContext[lanIndex].reviewOrder}</IconTitle2>
                            </TableDisplay>

                            {hasAdvocado &&
                                <TableDisplay themeContext={themeContext} onClick={() => {
                                    adCustomer ? setShowAdCustomer(true) : setShowAdvocadoLogin(true)
                                    // setShowAdCustomer(true);
                                }}>
                                    <IoPersonOutline fontSize={24} />
                                    {/* <IconTitle>{adCustomer ? languageContext[lanIndex].memberInfo : languageContext[lanIndex].MemberLogin}</IconTitle> */}
                                </TableDisplay>
                            }
                            {hasMember &&
                                <TableDisplay themeContext={themeContext} onClick={() => {
                                    customer ? setShowCustomer(true) : setShowCustomerLogin(true)
                                    // setShowAdCustomer(true);
                                }}>
                                    <IoPersonOutline fontSize={24} />
                                    {/* <IconTitle>{customer ? languageContext[lanIndex].memberInfo : languageContext[lanIndex].MemberLogin}</IconTitle> */}
                                </TableDisplay>
                            }
                        </>
                    }
                </RightWrapper>
            </HeaderDisplay>
            {showOrder &&
                <ReviewOrderModal
                    show={showOrder}
                    setShow={setShowOrder}
                />
            }
            {showAdvocadoLogin &&
                <AdvocadoLogin
                    show={showAdvocadoLogin}
                    setShow={setShowAdvocadoLogin}
                    handleCallback={showAdC}
                />
            }
            {showAdCustomer &&
                <AdvocadoPage
                    show={showAdCustomer}
                    setShow={setShowAdCustomer}
                />
            }
            {showCustomer &&
                <CustomerDetail
                    show={showCustomer}
                    setShow={setShowCustomer}
                />
            }
            {showCustomerLogin &&
                <CustomerLogin
                    show={showCustomerLogin}
                    setShow={setShowCustomerLogin}
                />
            }
            {showTakeawayEditor &&
                <TakeAwayModal
                    show={showTakeawayEditor}
                    setShowTk={setShowTakeawayEditor}
                    confirmTKCheckOut={updateTakeawayInfo}
                    lanIndex={lanIndex}
                    deliveryType={Number(takeAwayInfo.deliveryType)}
                    dt={bookingDate}
                    nm={takeAwayInfo.customerName || ""}
                    ph={takeAwayInfo.phone || ""}
                    addr={deliveryAddressParts.address}
                    rm={takeAwayInfo.roomNo || ""}
                    remarkValue={takeAwayInfo.remark || ""}
                    selectedCheckboxs={takeAwayInfo.checkbox || []}
                    postalValue={takeAwayInfo.postal || deliveryAddressParts.postal}
                    unitValue={takeAwayInfo.unit || deliveryAddressParts.unit}
                    setDeliveryPrice={(value, baseValue = value) => {
                        setEditorDeliveryPrice(value);
                        setEditorBaseDeliveryPrice(baseValue);
                    }}
                    deliveryPrice={editorDeliveryPrice}
                    totalAmount={0}
                    currencySymbol={currencySymbol}
                />
            }
        </React.Fragment>
    )



}

export default Header;
const MobileIdentity = styled.div`
  display: none;
  @media (max-width: 767px) {
    display: flex;
    width: 100%;
    height: ${props => props.collapsed ? 34 : 72}px;
    gap: 12px;
    align-items: center;
    text-align: left;
    color: ${props => readableText(props.themeContext.backgroundColor, props.themeContext.fontPrimary)};
    font-family: ${props => props.themeContext.fontFamily};
    img { flex: 0 0 44px; width: 44px; height: 44px; object-fit: cover; border-radius: 10px; }
    .identity-text { display: flex; flex: 1; min-width: 0; flex-direction: ${props => props.collapsed ? "row" : "column"}; justify-content: space-between; gap: 3px; }
    strong { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: ${props => props.collapsed ? 10 : 16}px; font-weight: ${props => props.collapsed ? 400 : 700}; }
    .identity-text span { font-size: 10px; white-space: nowrap; color: ${props => readableText(props.themeContext.backgroundColor, props.themeContext.primaryColor)}; }
    .customer-text { display: flex; flex-direction: column; align-items: flex-end; gap: 2px; max-width: 40%; font-size: ${props => props.collapsed ? 10 : 12}px; color: ${props => readableText(props.themeContext.backgroundColor, props.themeContext.descriptionColor, "#626b62")}; }
    .order-type { font-weight: 600; }
    .schedule-text { text-align: left; font-size: 10px; line-height: 1.3; color: ${props => readableText(props.themeContext.backgroundColor, props.themeContext.descriptionColor, "#626b62")}; }
    button { padding: 0; border: 0; background: none; color: inherit; font-family: inherit; font-size: inherit; cursor: pointer; }
    .language-toggle {
      flex-shrink: 0;
      min-width: 32px;
      min-height: 32px;
      padding: 0 8px;
      border: 1px solid ${props => lightTint(props.themeContext.primaryColor, 0.3)};
      border-radius: 8px;
      background: ${props => lightTint(props.themeContext.primaryColor, 0.12)};
      color: ${props => readableText(lightTint(props.themeContext.primaryColor, 0.12), props.themeContext.fontPrimary)};
      font-size: 12px;
      font-weight: 600;
    }
    .language-toggle:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
  }
`;
const HeaderImg = styled.img`
    height: 40px;
    max-width: 80px;
    object-fit: contain;
    flex-shrink: 0;
    @media (max-width: 767px) {
      display: ${props => props.desktopOnly ? "none" : "block"};
    }
`;
const HeaderTxt = styled.div`
    display: flex;
    align-items: center;
    width: 200px;
    height: 40px;
    color: ${props => readableText(props.themeContext.menuHeaderColor, props.themeContext.headerColor)};
    border: none;
    background: none;
    padding-left: 12px;
    box-sizing: border-box;
    font-family: ${props => props.themeContext.fontFamily};
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    @media (max-width: 767px) {
      display: ${props => props.desktopOnly ? "none" : "flex"};
    }
`;
const SearchTxt = styled.input`
    &:focus-visible {
        outline: none;
    }
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
    height: 32px;
    box-sizing: border-box;
    border: none;
    background: none;
    margin: 0 6px 0 10px;
    padding: 0 8px;
    color: ${props => readableText(props.themeContext.menuHeaderColor, props.themeContext.headerColor)};
    border-bottom: 1px solid ${props => props.themeContext.headerColor};
    font-family: ${(props) => props.themeContext.fontFamily};
    font-size: 15px;
    animation: slidIn .1s;
    animation-timing-function: ease-out;
    @keyframes slidIn {
        0%  {
        transform: translateX(-200px);
        opacity: 0;
        }
        
        100%  {
        transform: translateX(0px);
        opacity: 1;
        }
        
    }

    @media (min-width: 768px) {
        flex: 0 1 520px;
        max-width: 520px;
        height: 40px;
        margin: 0 14px 0 20px;
        padding: 0 12px;
        font-size: 17px;
        border: 1px solid ${props => props.themeContext.headerColor};
        border-radius: 7px;
    }
`;
const RightWrapper = styled.div`
    display: ${(props) => props.isSearching ? "none" : "flex"};
    min-width: 0;
    align-items: center;
    justify-content: flex-end;
    flex-grow:1;
`;
const TakeawaySummary = styled.div`
  order: 10;
  display: ${(props) => props.desktopOnly || props.mobileCollapsed ? "none" : "flex"};
  flex: 0 0 100%;
  min-width: 0;
  height: 46px;
  padding: 6px 10px;
  box-sizing: border-box;
  align-items: center;
  gap: 10px;
  color: ${(props) => readableText(props.themeContext.menuHeaderColor, props.themeContext.headerColor)};
  background: rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.16);
  overflow: hidden;
  cursor: pointer;
  transition: background-color 150ms ease, box-shadow 150ms ease;

  &:hover {
    background: rgba(255, 255, 255, 0.17);
  }

  &:focus-visible {
    outline: 2px solid ${(props) => props.themeContext.headerColor};
    outline-offset: -3px;
  }

  @media (min-width: 768px) {
    order: initial;
    display: ${(props) => props.desktopOnly ? "flex" : "none"};
    flex: 0 1 auto;
    width: auto;
    max-width: min(48vw, 650px);
    height: 46px;
    margin: 0 12px 0 0;
    padding: 5px 12px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.12);
    align-self: center;
  }
`;
const OrderTypePill = styled.span`
  flex: 0 0 auto;
  padding: 5px 9px;
  border-radius: 999px;
  color: ${(props) => props.themeContext.menuHeaderColor};
  background: ${(props) => props.themeContext.headerColor};
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
`;
const TakeawayDetail = styled.span`
  display: flex;
  min-width: 0;
  max-width: ${(props) => props.location ? "240px" : "180px"};
  flex: ${(props) => props.location ? "1 1 150px" : "0 1 auto"};
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.15;

  @media (max-width: 430px) {
    &:nth-of-type(3) {
      display: none;
    }
  }
`;
const DetailLabel = styled.span`
  margin-bottom: 3px;
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.08em;
  opacity: 0.72;
  text-transform: uppercase;
  white-space: nowrap;
`;
const DetailValue = styled.span`
  display: block;
  width: 100%;
  overflow: hidden;
  font-size: 11px;
  font-weight: 650;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const ViewBillButton = styled.button`
  display: none;
  flex-shrink: 0;
  height: 46px;
  padding: 0 18px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 1px solid ${props => lightTint(props.themeContext.primaryColor, 0.3)};
  border-radius: 999px;
  color: ${props => readableText(props.themeContext.backgroundColor, props.themeContext.fontPrimary)};
  background: ${props => props.themeContext.backgroundColor};
  font-family: ${props => props.themeContext.fontFamily};
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  &:focus-visible { outline: 2px solid ${props => props.themeContext.primaryColor}; outline-offset: 2px; }
  @media (min-width: 768px) { display: flex; }
`;
const MobileCartButton = styled.button`
  display: none;
  flex-shrink: 0;
  height: 46px;
  margin: 0 12px 0 8px;
  padding: 0 20px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 1px solid ${props => lightTint(props.themeContext.primaryColor, 0.3)};
  border-radius: 999px;
  color: ${props => actionTextColor(props.themeContext)};
  background: ${props => props.themeContext.primaryColor};
  font-family: ${props => props.themeContext.fontFamily};
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  &:focus-visible { outline: 2px solid ${props => props.themeContext.headerColor}; outline-offset: 2px; }
  @media (min-width: 768px) { display: flex; }
`;
const IconButton = styled.div`
    color: ${(props) => props.themeContext.fontSecondary};
    display: flex;
    right: 0.5rem;
   
    justify-content: center;
    align-items: center;
    margin-left: 4px;
    margin-right: 4px;
    z-index: 5;
`;
const TableDisplay = styled.div`
  display: flex;
  right: 0.5rem;
  text-align: right;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  margin-right: 4px;
  font-weight: 400;
  font-family: ${(props) => props.themeContext.fontFamily};
  color: ${(props) => readableText(props.themeContext.menuHeaderColor, props.themeContext.headerColor)};
  z-index: 5;
  cursor: pointer;
  height: 40px;
  @media (min-width: 768px) {
    display: ${(props) => props.hideAtDesktop ? "none" : "flex"};
  }
`;
const IconTitle = styled.div`
    font-size: 10px;
    text-wrap: wrap;
    text-align: left;
    padding-left: 4px;
    width: 38px;
    line-height: 12px;
`;

const IconTitle2 = styled.div`
    font-size: 10px;
    text-wrap: wrap;
    text-align: left;
    padding-left: 4px;
    width: 29px;
    line-height: 12px;
`;

//Styled Components
const HeaderDisplay = styled.div`
  display: flex;
  position: fixed;
  top: 0rem;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  background-color: ${(props) => props.themeContext.menuHeaderColor};
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  box-shadow: 0px 0px 3px rgba(0,0,0,0.7);
  height: ${(props) => props.themeContext.headerHeight + (props.hasTakeawayDetails && !props.mobileCollapsed ? 46 : 0)}px;
  flex-wrap: wrap;
  align-content: flex-start;
  transition: height 180ms ease;
  width: 100%;
  @media (max-width: 767px) {
    ${props => props.mobileMenuHeader && `
      height: ${(props.mobileCollapsed && !props.isSearching ? 34 : 72)}px;
      padding: 0 14px;
      background: ${props.themeContext.backgroundColor};
      align-content: center;
      color: ${readableText(props.themeContext.backgroundColor, props.themeContext.fontPrimary)};
      input { color: ${readableText(props.themeContext.backgroundColor, props.themeContext.fontPrimary)}; border-color: ${readableText(props.themeContext.backgroundColor, props.themeContext.fontPrimary)}; }
      > div { color: ${readableText(props.themeContext.backgroundColor, props.themeContext.fontPrimary)}; }
      box-shadow: none;
      border-bottom: 1px solid ${props.themeContext.borderColor || "#eee"};
      ${!props.isSearching ? "> :not([data-mobile-identity]) { display: none; }" : ""}
    `}
  }
  //Adjust the image height to be adjusted based on the screen size at a later date.
  z-index: 5;
  max-width: ${(props) => props.maxWidth ? `${props.maxWidth}px` : (props.wide ? "none" : "550px")};
  padding: 0 8px;
  @media (min-width: 768px) {
    height: ${(props) => props.wide ? "60px" : `${props.themeContext.headerHeight}px`};
    flex-wrap: nowrap;
    align-content: center;
    padding: ${(props) => props.wide ? "0 18px" : "0"};
  }
`;

const HeaderLogo = styled.div`
  position: absolute;
  height: 24px;
  width: 100%;
  flex-grow: 1;
  margin-top: 8px;
  margin-bottom: 8px;
  background-image: url(${(props) => `https://ireachfnb.com${props.image}`});
  /*background-image: url(${(props) => `https://newdemo.chachingfnb.com${props.image}`});*/
  background-size: contain;
  background-position: ${(props) => props.themeContext.headerLogoPosition};
  background-repeat: no-repeat;
`;


const TableLanWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 5;
  height: 100%;
  color: ${(props) => readableText(props.themeContext.menuHeaderColor, props.themeContext.headerColor)}
`;

const TableLan = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    padding: 0 4px;
`;
